import pathToRegexp from 'path-to-regexp';

export default (path, params = {}) => {
  let url = pathToRegexp.compile(path)(params);

  // TODO[GB] aggiunto per non perdere la query string
  try {
    const search = window?.location?.search;
    if (search) url += search;
  } catch (error) {
    console.error(error);
  }
  return url;
};
